import { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";

type ReasonModalProps = {
  open: boolean;
  title: string;
  description?: string;
  isSubmitting?: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (reason: string) => void;
};

const ReasonModal = ({
  open,
  title,
  description,
  isSubmitting = false,
  onOpenChange,
  onSubmit,
}: ReasonModalProps) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setReason("");
      setError("");
    }
  }, [open]);

  const handleSubmit = () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      setError("Please enter a reason");
      return;
    }
    onSubmit(trimmed);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? (
            <DialogDescription>{description}</DialogDescription>
          ) : null}
        </DialogHeader>
        <div className="space-y-1.5">
          <Label className="text-sm text-[#374151]">
            Reason <span className="text-red-500">*</span>
          </Label>
          <Textarea
            placeholder="Enter reason..."
            value={reason}
            onChange={e => {
              setReason(e.target.value);
              if (error) {
                setError("");
              }
            }}
            className="min-h-[110px] resize-none bg-white"
            disabled={isSubmitting}
          />
          {error ? <p className="text-xs text-red-500">{error}</p> : null}
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            type="button"
            variant="outline"
            disabled={isSubmitting}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            disabled={isSubmitting}
            onClick={handleSubmit}
            className="bg-primary hover:bg-primary/90 text-white"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReasonModal;
